export enum SearchContext {
    DEFAULT = 'default',
    SMS = 'sms',
}
